import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 10px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
`

export const badge = css`
  span {
    top: 2px;
    right: 2px;
  }
`

export const header = css`
  padding-bottom: 8px;
`

export const body = css`
  padding-bottom: 2px;
`

export const footer = css`
  padding-top: 8px;
`
